/**
 * @ngdoc overview
 * @name cbl.telepass.wa
 * @description Modulo funzionale dell'applicazione Credito Assicurativo PMI
 */
(function () {
  'use strict';
  angular.module('cbl.telepass.wa', [
    '$scope',
    'ui.router',
    'ui.bootstrap',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.cellNav',
    'ui.grid.edit',
    'ui.grid.exporter',
    'ui.grid.grouping',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.rowEdit',
    'ui.grid.selection',
    'ui.grid.treeView',
    'cbl.telepass.wa.directives',
    'cbl.common',
    'ngSanitize',
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/app.module.js
// module id = 1
// module chunks = 0